import { writable } from "svelte/store";

// 도움말 플로팅 윈도우 표시 여부
export const helpOpen = writable(false);

export function openHelp() {
    helpOpen.set(true);
}

export function closeHelp() {
    helpOpen.set(false);
}

export function toggleHelp() {
    helpOpen.update((v) => !v);
}
